
const state = {
  isJida: false,
  fileApi: SERVERCONFIG.VUE_APP_BASE_API + '/fjxhx/file/server/api/file/',
  clientId: SERVERCONFIG.clientId,
  clientSecret: SERVERCONFIG.clientSecret,
  otherClientId: SERVERCONFIG.otherClientId,
  otherClientSecret: SERVERCONFIG.otherClientSecret
}

const mutations = {
  SET_ISJIDA: (state, value) => {
    state.isJida = value
  },
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/settings.js